import axios from "axios";

axios.defaults.headers.Authorization = `Bearer ${localStorage.getItem(
    "accessToken"
)}`;

axios.defaults.headers['X-Locale'] = window.location.pathname.split('/')[1];

let baseURL = process.env.VUE_APP_DEFAULT_API_URL

if (process.env.NODE_ENV == 'production') {
    if (window.location.origin == 'https://platform-stage.roadcube.app') {
        baseURL = process.env.VUE_APP_API_URL_FOR_APP
    }else if (window.location.origin == 'https://platform.roadcube.io') {
        baseURL = process.env.VUE_APP_API_URL_FOR_IO
    }else if (window.location.origin == 'https://platform-feature.roadcube.app') {
        baseURL = process.env.VUE_APP_API_URL_FOR_FEATURE
    }
}

export default axios.create({
        baseURL: baseURL
    });

